import React from 'react';
import logo from './logo.svg';
import './App.css';
import ShowRanks from './Components/RanksOverView/RanksOverView';

function App() {
  return (
    <div className="App">
      <ShowRanks></ShowRanks>
    </div>
  );
}

export default App;
